import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'unitNameTrim'})

export class UnitNameTrim implements PipeTransform {
  transform(value: string, args: string[]): any {
    if (!value) return value;

    let temp = value.split("-");
    let unitSite = temp[0];
    let unitId = temp[1];
    let unitSize = temp[4];
    let unitPlacement = temp.pop();

    return unitId + '-' + unitSite + '-' + unitSize + '-' + unitPlacement
  }
}
